import React from 'react'
import styled from 'styled-components'
import { storyblokEditable, SbBlokData, Richtext } from '@storyblok/react'
import { containerDefault } from '../../lib/styles/Container'
import { renderRichtext } from '../../lib/utils/renderRichtext'
import { LogoCarousel, LogoCarouselProps } from '../LogoCarousel'

const Wrapper = styled.div<{ $backgroundColor: string; $blockBorderRadius?: string, $margin?: string }>`
    ${containerDefault}
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    border-radius: ${props => props.$blockBorderRadius || '0.5rem'};
    justify-content: center;
    background-color: ${props => props.$backgroundColor || 'transparent'};
    
    @media screen and (max-width: 768px) {
        margin: ${props => props.$margin || '1rem auto'};
        width: 100%;
        max-width: 100%;
    }
`

const Container = styled.div<{ $imagePosition?: 'left' | 'right'; $padding?: string }>`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 2rem;
  padding: ${props => props.$padding || '1rem 0'};
  align-items: center;
  direction: ${props => props.$imagePosition === 'left' ? 'rtl' : 'ltr'};

  > * {
    direction: ltr;
  }

  @media screen and (max-width: 820px) {
    grid-template-columns: 1fr;
  }
`

const TextContent = styled.div`
  padding: 1rem;
`

const Heading = styled.h2<{ $fontSize?: string; $textColor?: string }>`
  color: ${props => props.$textColor || 'var(--Black-black-1, #0D0D0D)'};
  font-size: ${props => props.$fontSize || '2.5rem'};
  font-style: normal;
  font-weight: 700;
  line-height: 115%;
  text-align: center;
  margin-bottom: 1rem;
`

const Description = styled.p<{ $fontSize?: string; $textColor?: string }>`
  font-size: ${props => props.$fontSize || '1.125rem'};
  color: ${props => props.$textColor || 'inherit'};
  line-height: 1.6;
  text-align: center;
`

const ImageWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 2rem;
`

export interface IntegrationModuleContentProps {
  blok: {
    backgroundColor: string
    heading: string
    description: string
    headingFontSize?: string
    headingColor?: string
    descriptionFontSize?: string
    descriptionColor?: string
    integrationImages: LogoCarouselProps['blok'][]
  }
}


const IntegrationModuleContent = ({ blok }: IntegrationModuleContentProps & { blok: SbBlokData }) => {

  console.log(blok, 'brate bruklin')
  return (
    <Wrapper $backgroundColor={String(blok.backgroundColor)} $blockBorderRadius={String(blok.blockBorderRadius)} $margin={String(blok.margin)}>
      <TextContent>
        <Heading
          $fontSize={String(blok.headingFontSize)}
          $textColor={String(blok.headingColor)}
        >
          {blok.heading}
        </Heading>
        <Description
          $fontSize={String(blok.descriptionFontSize)}
          $textColor={String(blok.descriptionColor)}
        >
          {blok.description}
        </Description>
        <div className="prose">{renderRichtext(blok.richtext as Richtext)}</div>
      </TextContent>
      <ImageWrapper>
        {blok.integrationImages && blok.integrationImages.map((logoCarouselItem: LogoCarouselProps['blok'], index: number) => (
          <LogoCarousel blok={{ ...logoCarouselItem, _uid: 'LogoCarousel', component: 'LogoCarousel', imageSize: '3rem', rowCount: 5 }} key={index} />
        ))}
      </ImageWrapper>
    </Wrapper>
  )
}

export default IntegrationModuleContent